import { jsx } from '@emotion/core';
import { isTopLevel } from '..';
import { Line } from './components';
import TopLevelBlock from './TopLevelBlock';
const renderElement = (props) => {
    const { children, element, attributes } = props;
    if (element.type === 'line') {
        return jsx(Line, Object.assign({}, attributes), children);
    }
    if (!isTopLevel(element)) {
        return jsx("div", Object.assign({}, attributes), children);
    }
    return (jsx(TopLevelBlock, { element: element, attributes: attributes }, children));
};
export default renderElement;
//# sourceMappingURL=renderElement.js.map